import { GroupMemberRole } from './GroupMemberRole';
import type { UserId, GroupMemberRolesJSON } from 'balus-common';

type GroupMemberRoleRecord = Record<UserId, GroupMemberRole>;

export class GroupMemberRoles {
  private readonly memberRoles: Readonly<GroupMemberRoleRecord>;
  constructor(memberRoles: GroupMemberRoleRecord) {
    this.memberRoles = { ...memberRoles };
  }

  dump(): GroupMemberRolesJSON {
    return { ...this.memberRoles };
  }

  static load(dump: GroupMemberRolesJSON | null): GroupMemberRoles {
    return this.fromEntries(Object.entries(dump || {}));
  }

  static fromEntries(entries: [string, string][]): GroupMemberRoles {
    const memberRoles: GroupMemberRoleRecord = {};
    for (const [userId, role] of entries) {
      memberRoles[userId] = GroupMemberRole.load(role);
    }
    return new this(memberRoles);
  }

  get length(): number {
    return Object.keys(this.memberRoles).length;
  }

  getRoleOf(userId: UserId): GroupMemberRole | undefined {
    return this.memberRoles[userId];
  }

  regularUserIds(): UserId[] {
    return Object.entries(this.memberRoles)
      .filter(([, role]) => role !== 'guest')
      .map(([userId]) => userId);
  }

  guestUserIds(): UserId[] {
    return Object.entries(this.memberRoles)
      .filter(([, role]) => role === 'guest')
      .map(([userId]) => userId);
  }

  userIds(): UserId[] {
    return Object.keys(this.memberRoles);
  }
}
